import React from "react";
import { Link } from "react-router-dom";
import aboutbanner from "../assets/images/aboutus_tour.webp";
import HeroLayout from "../components/HeroLayout";
import Partners from "../components/Partners";
const images = require.context("../assets/images", false);

function About() {
  return (
    <>
    <HeroLayout>
            <div
            className="banner-bg bg-bottom bgbottom about-hero"
            style={{
                backgroundImage: `linear-gradient(#370b2e66,#370b2e66),url(${aboutbanner})`
            }}
            
            >
            <div className="container">
                <div className="inner-banner-content full-width center color-white mt-5">
                <h1>The Golden Triangle Tour Experts</h1>
                </div>
            </div>
            </div>
            </HeroLayout>
            <main className="about-page">
           <div className="mt-80 about-GEH justify-content">
  <div className="container">
    <div className="row align-items-center desktopview">
      <div className="col-md-4">
        <div className="about-image smal mb-3">
          <img src={images("./13.jpg.jpeg")} />
        </div>
      </div>
      <div className="col-md-8">
        <div className="about-content smal">
          <h2>About Us</h2>
          <p>
            With more than 12+ years of experience in the Indian travel industry
            and a dedicated team to personalize your trip, we are one of the
            best travel companies offering the Golden Triangle Tour. We provide
            personalized service to each guest which ensures every small detail
            will be attended to. We believe in quality and our highly
            experienced and passionate team guarantee a trip that will go above
            and beyond your expectations. Come travel with us!
          </p>
<p>Our parent company, <Link to="https://www.virsatravels.com/">VIRSA TRAVELS</Link>, holds the following accreditations.</p>
          <div className="d-flex gap-3">
          <div className="increadle-inda">
            <img src={images("./foot1.png")} />
            <p className="center color-white mt-2">Lic No. UDYAM-HR-19-0000528</p>
          </div>
          <div className="increadle-inda">
            <img src={images("./foot2.png")} />
            <p className="center color-white mt-2">Lic No. EHR000176</p>
          </div>
        </div>

        </div>
      </div>
      <div className="col-md-12">
  <div className="about-content p-0 mb-3 mbtop">
    <h3>How are We Different?</h3>
    <p className="font-15">
      This question is very genuine &amp; may come into minds of many of you. We
      are a boutique travel company which provides tailor made tours and
      personalised services to our guests. We are different as beside these
      traditional tours, we also aim at providing Unique Experiences to our
      guest. To name few of them: Culinary tours, Learn an art like pottery,
      instrument playing, cooking etc., Farm tours, Attend an Indian wedding,
      Home stay, Teach in village school, Get a heena tattoo, Wear a suit/saree
      &amp; many more.
    </p>
  </div>
  <div className="about-content p-0 mb-3">
    <h3>We are Social Too</h3>
    <p className="font-15">
      We are a social organisation and aim to contribute towards the society by
      generating employment opportunities for local people, empowering women by
      giving boost to local souvenirs, adopting eco-friendly activities &amp;
      contributing in non-profit social activities. So book your holidays with
      us and be a contributor in making a difference for the better in the lives
      of local people.
    </p>
  </div>
</div>

    </div>

   <div className="row align-items-center mobileview">
      
      <div className="col-md-12">
        <div className="about-content smal">
          <h2>About Us</h2>
          <p>
            With more than 12+ years of experience in the Indian travel industry
            and a dedicated team to personalize your trip, we are one of the
            best travel companies offering the Golden Triangle Tour. We provide
            personalized service to each guest which ensures every small detail
            will be attended to. We believe in quality and our highly
            experienced and passionate team guarantee a trip that will go above
            and beyond your expectations. Come travel with us!
          </p>

          <div className="d-flex gap-3 mobileviewmargin">
          <div className="increadle-inda">
            <img src={images("./foot1.png")} />
            <p className="center color-white mt-2">Lic No. UDYAM-HR-19-0000528</p>
          </div>
          <div className="increadle-inda">
            <img src={images("./foot2.png")} />
            <p className="center color-white mt-2">Lic No. EHR000176</p>
          </div>
        </div>

        </div>
      </div>

      <div className="col-md-12">
  <div className="about-content p-0 mb-3 mbtop">
    <h3>How are We Different?</h3>
    <p className="font-14">
      This question is very genuine &amp; may come into minds of many of you. We
      are a boutique travel company which provides tailor made tours and
      personalised services to our guests. We are different as beside these
      traditional tours, we also aim at providing Unique Experiences to our
      guest. To name few of them: Culinary tours, Learn an art like pottery,
      instrument playing, cooking etc., Farm tours, Attend an Indian wedding,
      Home stay, Teach in village school, Get a heena tattoo, Wear a suit/saree
      &amp; many more.
    </p>
  </div>
  <div className="about-content p-0 mb-3">
    <h3>We are Social Too</h3>
    <p className="font-14">
      We are a social organisation and aim to contribute towards the society by
      generating employment opportunities for local people, empowering women by
      giving boost to local souvenirs, adopting eco-friendly activities &amp;
      contributing in non-profit social activities. So book your holidays with
      us and be a contributor in making a difference for the better in the lives
      of local people.
    </p>
  </div>
</div>
      <div className="col-md-12">
        <div className="about-image smal mb-3">
          <img src={images("./raj.webp")} />
        </div>
      </div>
    </div>





  </div>
</div>

<div className="review-bar-about mt-50">
  <div className="container">
    <div className="inner-review-bar max-800">
      <div className="row">
        <div className="col-6 col-md-3">
          <div className="review-bar-card center">
            <h2>12+</h2>
            <p>Years of Experience</p>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="review-bar-card center">
            <h2>35+</h2>
            <p>Local Families Supported</p>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="review-bar-card center">
            <h2>98%</h2>
            <p>Positive Reviews</p>
          </div>
        </div>
        <div className="col-6 col-md-3">
          <div className="review-bar-card center">
            <h2>700+</h2>
            <p>Happy Clients</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div className="specialists mt-20">
  <div className="inner-specialists">
    <div className="container">
      <div className="heading center">
        <h2>Our Team</h2>
      </div>
      <div className="row">
        <div className="col-md-6 col-lg-3">
          <div className="experts-card about-var">
            <img src={images("./r1.webp")} />
            <div className="experts-card-details">
              <h5>Rahul Walia</h5>
              <p>Founder | Head - Sales &amp; Operations</p>
<p className="mt-2 font-14 textjustify">
Rahul is a tourism professional with a Master's degree in Tourism Administration and over 13 years of experience serving international tourists. His deep expertise and commitment to excellence have established him as a trusted authority in the global tourism industry, delivering exceptional experiences to travelers worldwide.
              </p>
            </div>
          </div>
        </div>
        
        <div className="col-md-6 col-lg-3 mb-40">
          <div className="experts-card about-var">
            <img src={images("./ankit.jpg")} />
            <div className="experts-card-details">
              <h5>Ankita</h5>
              <p>Tour Sales</p>
              <p className="mt-2 font-14 textjustify">
              Ankita is a distinguished professional with a Master's degree in Commerce and over 10 years of experience in tour sales and operations within the inbound tourism sector. Her comprehensive expertise and dedication to seamless travel experiences have established her as a reliable and accomplished leader in the tourism industry.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 mb-40 mobileviewmb">
          <div className="experts-card about-var">
            <img src={images("./Rajat-1.jpeg")} />
            <div className="experts-card-details">
              <h5>Rajat</h5>
              <p>Information Technology</p>
              <p className="mt-2 font-14 textjustify">
Rajat is a skilled professional with a Bachelor's degree in Technology and over 13 years of experience managing and enhancing the company's digital presence. His technical acumen and forward-thinking approach ensure a strong and impactful footprint across all digital platforms.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-3 mb-40 mobileviewmb">
          <div className="experts-card about-var">
            <img src={images("./girsih.jpg")} />
            <div className="experts-card-details">
              <h5>Girish</h5>
              <p>Transport</p>  
              <p className="mt-2 font-14 textjustify">
Girish is a seasoned veteran of the tourism industry with over 35 years of rich experience and knowledge. Like an ancient tree with deep roots, his wisdom and expertise serve as a strong pillar of our organization. He heads our transport division, ensuring smooth and reliable operations at every step.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<Partners />
<div className="add-banner">
  <img src={images("./support-banner.jpeg")} />
</div>
</main>
</>
  );
}

export default About;
